@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Producto</h1>

  <form
    [formGroup]="productForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <div class="flex flex-col gap-2">
      <label for="product-name">Nombre del Producto</label>
      <input
        type="text"
        id="product-name"
        formControlName="name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="product-sku">SKU</label>
      <input
        type="text"
        id="product-sku"
        formControlName="sku"
        class="basic-input"
        (click)="generateSku()"
      />
      <!-- (focus)="generateSku()" -->
    </div>

    <div class="flex flex-col gap-2">
      <label for="product-description">Descripción</label>
      <textarea
        id="product-description"
        formControlName="description"
        class="basic-input h-20 resize-y"
      ></textarea>
    </div>

    <div class="flex flex-col gap-2">
      <label for="product-categories">Categorías</label>
      <ng-select
        id="product-categories"
        [items]="categories"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [searchable]="true"
        [closeOnSelect]="false"
        formControlName="categoryIds"
      >
      </ng-select>
    </div>

    <div class="flex flex-row gap-x-2">
      <div class="flex flex-col gap-2">
        <!-- w-28 -->
        <label for="product-price-retail">Precio Menudeo</label>
        <input
          type="number"
          id="product-price-retail"
          formControlName="price_retail"
          class="basic-input"
        />
      </div>

      <div class="flex flex-col gap-2">
        <!-- w-28 -->
        <label for="product-price-wholesale">Precio Mayoreo</label>
        <input
          type="number"
          id="product-price-wholesale"
          formControlName="price_wholesale"
          class="basic-input"
        />
      </div>

      <div class="flex flex-col gap-2">
        <!-- w-28 -->
        <label for="product-price-roll">Precio por Rollo</label>
        <input
          type="number"
          id="product-price-roll"
          formControlName="price_roll"
          class="basic-input"
        />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label for="product-uom">Unidad de Medida</label>
      <ng-select
        id="product-uom"
        [items]="uoms"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="false"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="uom"
      >
      </ng-select>
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button
        type="submit"
        [disabled]="productForm.invalid"
        class="primary normal"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage && productForm.pristine) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage && productForm.pristine) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>

  <!-- @if (errorMessage ) {
  <span class="mt-4 text-red-700 text-sm">{{ errorMessage }}</span>
  } -->
</app-modal>
}
